import React from 'react'

import SelectOPMELayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/SelectOPME'

const SelectOPME = () => <SelectOPMELayout />

export default SelectOPME
